export default "__VITE_ASSET__BIjZWavQ__"